import domSerializer from "dom-serializer";
import { parseDocument } from "htmlparser2";
import { pipe } from "ramda";
import slugify from "../../utils/slugify";

export const resolveAbsoluteInternalUrls = (html: string) =>
  html.replace(/href="https?:\/\/fotbolltransfers\.com/g, 'href="');

export const resolveImageSources = (html: string) =>
  html.replace(
    /"\/uploads/g,
    `"${process.env.NEXT_PUBLIC_ASSET_SERVER_URL}/uploads`
  );

export const resolveImageWidths = (html: string) =>
  html.replace(/width: 350+px;/g, "width:100%;");

export const resolveFacebookWidth = (html: string) =>
  html.replace(
    /<iframe((.|\n|\r)*?)facebook((.|\n|\r)*?)(width="\d+")/g,
    (str) => str.replace(/width="\d+"/g, 'width="100%"')
  );

export const resolveYoutubeWidth = (html: string) =>
  html.replace(
    /<iframe((.|\n|\r)*?)youtube((.|\n|\r)*?)(width="\d+")/g,
    (str) => str.replace(/width="\d+"/g, 'width="100%"')
  );

export const resolveLinks = (html: string) => {
  const regex = /href="(.*?)".*?>(.*?)</g;

  return html.replace(regex, (_, url, text) => {
    const urlContext = getArticleBodyUrl(url, slugify(text));
    if (!urlContext) return url;
    return `href="${urlContext.url}">${text}<`;
  });
};

export const getType = (route: string) => {
  // might need to add more types here
  if (route.includes("club")) return "club";
  if (route.includes("manager")) return "manager";
  if (route.includes("agent")) return "agent";
  if (route.includes("league")) return "league";
  if (route.includes("news")) return "news";

  return "player";
};

export const getArticleBodyUrl = (url: string, slug?: string) => {
  const isExternal = url.startsWith("http");
  if (isExternal) return { type: "external", url };
  const regex = /\/(\d+)$/g;
  const id = regex.exec(url)?.[1];

  if (!id) return { type: "external", url };

  const type = getType(url);

  if (type === "club")
    return {
      type: "internal",
      url: `/klubbar/land/${slug || "slug"}/${id}`, // TODO add "land" to url
    };
  if (type === "player")
    return { type: "internal", url: `/spelare/${slug || "slug"}/${id}` };
  if (type === "manager")
    return { type: "internal", url: `/tranare/${slug || "slug"}/${id}` };
  if (type === "league")
    return { type: "internal", url: `/ligor/land/${slug || "slug"}/${id}` }; // TODO add "land" to url
  if (type === "agent")
    return { type: "internal", url: `/agenter/${slug || "slug"}/${id}` };
  if (type === "news")
    return { type: "internal", url: `/nyheter/${slug || "slug"}/${id}` };

  return null;
};

export const resolveHtml = pipe(
  resolveYoutubeWidth,
  resolveFacebookWidth,
  resolveImageSources,
  resolveImageWidths,
  resolveLinks,
  resolveAbsoluteInternalUrls
);

export const getArticleSegments = (html: string) => {
  const dom = parseDocument(html);

  const segments = (dom.children || [])
    .filter((node) => node.type !== "text")
    .map((node) => domSerializer(node));

  return segments;
};
